import { ChatSessionService, InputState } from "../../../services/chat-session.service";

export interface HideInputData {
  hideInput: boolean;
}

export function HideInputHandler(data: HideInputData, webchat: any, chatSession: ChatSessionService) {
    if (data?.hideInput == null) {
        console.warn('Trying change input visibility but no property "hideInput" was sent');
        return;
    }

    webchat.hideInput = data.hideInput;
    chatSession.setInputState(data.hideInput ? InputState.Hidden : InputState.Shown)
}
